import React, { useState } from 'react';
import { Menu, X, Globe, Phone, Mail, ChevronDown } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [servicesOpen, setServicesOpen] = useState(false);
    const location = useLocation();
    const isActive = (path) => location.pathname === path;

    return (
        <nav className="bg-white shadow-lg sticky top-0 z-50">
            {/* Top Bar */}
            <div className="bg-gradient-to-r from-green-900 to-green-700 text-white">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex justify-between items-center py-2 text-sm">
                        <div className="flex items-center gap-6">
                            <div className="flex items-center gap-2">
                                <Phone size={14} />
                                {/* <span>+91 63520 68269</span> */}
                                <a
                                    href="tel:+916352068269"
                                    className="hover:text-green-200 transition-colors"
                                >
                                    +91 63520 68269
                                </a>
                            </div>
                            <div className="hidden md:flex items-center gap-2">
                                <Mail size={14} />
                                {/* <span>info@nuranienterprise.com</span> */}
                                <a
                                    href="https://mail.google.com/mail/?view=cm&fs=1&to=sales.nuranienterprise@gmail.com&su=Trade Inquiry&body=Hello Nurani Enterprise,"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="hover:text-green-200 transition-colors"
                                >
                                    sales.nuranienterprise@gmail.com
                                </a>
                            </div>
                        </div>
                        {/* <div className="flex items-center gap-2">
                            <Globe size={14} />
                            <span>Nurani Enterprise</span>
                        </div> */}
                    </div>
                </div>
            </div>

            {/* Main Navbar */}
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between items-center h-20">
                    {/* Logo */}
                    <div className="flex-shrink-0">
                        <Link to="/" className="text-3xl uppercase font-bold bg-green-600 bg-clip-text text-transparent">
                            Nurani Enterprise
                        </Link>
                        <p className="text-xs text-gray-500">International Trade Solutions</p>
                    </div>

                    {/* Desktop Menu */}
                    <div className="hidden lg:flex items-center space-x-8">
                        <Link
                            to="/"
                            className={`font-medium transition-colors duration-200 ${isActive("/")
                                ? "text-green-600 border-b-2 border-green-600 pb-1"
                                : "text-gray-700 hover:text-green-600"
                                }`}
                        >
                            Home
                        </Link>
                        <Link
                            to="/about"
                            className={`font-medium transition-colors duration-200 ${isActive("/about")
                                ? "text-green-600 border-b-2 border-green-600 pb-1"
                                : "text-gray-700 hover:text-green-600"
                                }`}
                        >
                            About Us
                        </Link>

                        {/* <div className="relative">
                            <button
                                onMouseEnter={() => setServicesOpen(true)}
                                onMouseLeave={() => setServicesOpen(false)}
                                className="flex items-center gap-1 text-gray-700 hover:text-green-600 font-medium transition-colors duration-200"
                            >
                                Services
                                <ChevronDown size={16} />
                            </button>
                            {servicesOpen && (
                                <div
                                    onMouseEnter={() => setServicesOpen(true)}
                                    onMouseLeave={() => setServicesOpen(false)}
                                    className="absolute top-full left-0 mt-2 w-56 bg-white rounded-lg shadow-xl py-2 border border-gray-100"
                                >
                                    <Link to="/services#export" className="block px-4 py-2 text-gray-700 hover:bg-green-50 hover:text-green-600 transition-colors">
                                        Export Services
                                    </Link>
                                    <Link to="/services#import" className="block px-4 py-2 text-gray-700 hover:bg-green-50 hover:text-green-600 transition-colors">
                                        Import Services
                                    </Link>
                                    <Link to="/services#logistics" className="block px-4 py-2 text-gray-700 hover:bg-green-50 hover:text-green-600 transition-colors">
                                        Logistics & Shipping
                                    </Link>
                                    <Link to="/services#consulting" className="block px-4 py-2 text-gray-700 hover:bg-green-50 hover:text-green-600 transition-colors">
                                        Trade Consulting
                                    </Link>
                                </div>
                            )}
                        </div> */}

                        <Link
                            to="/products"
                            className={`font-medium transition-colors duration-200 ${isActive("/products")
                                ? "text-green-600 border-b-2 border-green-600 pb-1"
                                : "text-gray-700 hover:text-green-600"
                                }`}
                        >
                            Products
                        </Link>
                        <Link
                            to="/contact"
                            className={`font-medium transition-colors duration-200 ${isActive("/contact")
                                ? "text-green-600 border-b-2 border-green-600 pb-1"
                                : "text-gray-700 hover:text-green-600"
                                }`}
                        >
                            Contact
                        </Link>
                        <button className="bg-gradient-to-r from-green-600 to-green-700 text-white px-6 py-2 rounded-full font-medium hover:shadow-lg transform hover:scale-105 transition-all duration-200">
                            Get Quote
                        </button>
                    </div>

                    {/* Mobile menu button */}
                    <div className="lg:hidden">
                        <button
                            onClick={() => setIsOpen(!isOpen)}
                            className="text-gray-700 hover:text-green-600 focus:outline-none"
                        >
                            {isOpen ? <X size={28} /> : <Menu size={28} />}
                        </button>
                    </div>
                </div>
            </div>

            {/* Mobile Menu */}
            {isOpen && (
                <div className="lg:hidden bg-white border-t border-gray-200">
                    <div className="px-4 pt-2 pb-4 space-y-2">
                        <a href="/" className="block py-2 text-gray-700 hover:text-green-600 font-medium">
                            Home
                        </a>
                        <a href="/about" className="block py-2 text-gray-700 hover:text-green-600 font-medium">
                            About Us
                        </a>
                        <div className="py-2">
                            <button
                                onClick={() => setServicesOpen(!servicesOpen)}
                                className="flex items-center gap-1 text-gray-700 hover:text-green-600 font-medium w-full"
                            >
                                Services
                                <ChevronDown size={16} className={`transform transition-transform ${servicesOpen ? 'rotate-180' : ''}`} />
                            </button>
                            {servicesOpen && (
                                <div className="ml-4 mt-2 space-y-2">
                                    <Link to="/services#export" className="block py-1 text-gray-600 hover:text-green-600">
                                        Export Services
                                    </Link>
                                    <Link to="/services#import" className="block py-1 text-gray-600 hover:text-green-600">
                                        Import Services
                                    </Link>
                                    <Link to="/services#logistics" className="block py-1 text-gray-600 hover:text-green-600">
                                        Logistics & Shipping
                                    </Link>
                                    <Link to="/services#consulting" className="block py-1 text-gray-600 hover:text-green-600">
                                        Trade Consulting
                                    </Link>
                                </div>
                            )}
                        </div>
                        <Link to="/products" className="block py-2 text-gray-700 hover:text-green-600 font-medium">
                            Products
                        </Link>
                        <Link to="/contact" className="block py-2 text-gray-700 hover:text-green-600 font-medium">
                            Contact
                        </Link>
                        <button className="w-full bg-gradient-to-r from-green-600 to-green-700 text-white px-6 py-2 rounded-full font-medium mt-4">
                            Get Quote
                        </button>
                    </div>
                </div>
            )}
        </nav>
    );
};

export default Navbar;
